export const list = {
  raw: {
    listStyle: 'none',
    m: 0,
    p: 0,
  },
}
